import { Pipe, PipeTransform } from '@angular/core';
import countryIso2to3 from 'country-iso-2-to-3';

@Pipe({
    name: 'stbyCountryAbbr',
})
export class CountryAbbrPipe implements PipeTransform {
    transform(alpha2 = 'en'): string {
        return countryIso2to3(alpha2);
    }
}
